<template>
  <div>
    <!-- PDF'e dahil EDİLMEYECEK Kontrol Butonları -->
    <div class="no-pdf-actions">
      <!-- <v-btn color="success" size="small" @click="bicimliKopyala">Biçimli Kopyala</v-btn> -->
      <v-btn color="primary" size="small" class="ml-2" @click="generatePDF">PDF İndir</v-btn>
    </div>

    <!-- PDF Oluşturulacak Alan -->
    <div id="yazdirilacak-alan" ref="pdfArea" class="form-container">
      <!-- Header / Logo Area -->
      <table class="header-table">
        <tr>
          <td class="logo-cell">
            <img width="56" height="56" src="../assets/amasya_logo.png" alt="Logo" />
          </td>
          <td class="title-cell">
            AMASYA ÜNİVERSİTESİ<br />
            SAĞLIK BİLİMLERİ FAKÜLTESİ<br />
            EBELİK BÖLÜMÜ<br />
            MEZUNİYET KRİTERLERİ ONAY FORMU
          </td>
        </tr>
      </table>

      <!-- Öğrenci Bilgileri -->
      <table class="bilgi-tablosu">
        <tbody>
          <tr>
            <th>ÖĞRENCİ ID</th>
            <td>{{ studentInfo.kullaniciId }}</td>
          </tr>
          <tr>
            <th>ÖĞRENCİ ADI SOYADI</th>
            <td>{{ studentInfo.name }}</td>
          </tr>
          <tr>
            <th>ÖĞRENCİ NUMARASI</th>
            <td>{{ studentInfo.number }}</td>
          </tr>
          <tr>
            <th>DANIŞMAN BİLGİLERİ</th>
            <td>{{ studentInfo.advisor }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Kriterler Tablosu -->
      <table class="kriter-tablosu">
        <thead>
          <tr>
            <th>KRİTERLER</th>
            <th>ONAYLANAN KRİTER SAYISI</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(kriter, index) in criteria" :key="index">
            <td>{{ kriter.label }}</td>
            <td class="center-text">{{ kriter.count }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Onay Metni -->
      <p class="onay-metni">
        Yukarıda bilgileri yer alan öğrencinin, Ebelik Lisans Programını başarıyla
        tamamlayabilmesi için belirlenen asgari mezuniyet kriterlerini sağladığı,
        ilgili komisyon tarafından yapılan inceleme ve değerlendirme sonucunda tespit
        edilmiştir.
      </p>

      <!-- İmza Tablosu -->
      <table class="imza-tablosu">
        <tr>
          <td>Komisyon Başkanı</td>
          <td>Komisyon Üyesi</td>
          <td>Komisyon Üyesi</td>
        </tr>
        <tr>
          <td>Tarih: .../.../.....</td>
          <td>Tarih: .../.../.....</td>
          <td>Tarih: .../.../.....</td>
        </tr>
        <tr class="imza-satiri">
          <td>İmza:</td>
          <td>İmza:</td>
          <td>İmza:</td>
        </tr>
      </table>

      <!-- Bölüm Başkanı -->
      <div class="bolum-baskani">
        <p class="bold-text">Bölüm Başkanı</p>
        <p class="imza-alani">İmza:</p>
      </div>

      <!-- Zaman Damgası Notu -->
      <p class="sistem-notu">
        Bu form www.form.amasya.edu.tr sistemi ile entegredir. Form çıktısı
        <strong>{{ formInfo.id }}</strong> id ve
        <strong>{{ formInfo.date }}</strong> tarihli zaman damgası ile kayıt altına alınmıştır.
      </p>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'GraduationCriteriaForm',
  props: {
    title: {
      type: String,
      default: 'Ebelik Lisans Programı Mezuniyet Kriterleri Değerlendirme Formu'
    },
    studentInfo: {
      type: Object,
      default: () => ({
        kullaniciId: '',
        name: '',
        number: '',
        advisor: ''
      })
    },
    formInfo: {
      type: Object,
      default: () => ({
        id: '',
        date: ''
      })
    },
    criteria: {
      type: Array,
      default: () => [
        { label: 'SAĞLIKLI GEBE İZLEMİ', count: '' },
        { label: 'RİSKLİ GEBE İZLEMİ', count: '' },
        { label: 'İNNATAL İZLEMİ', count: '' },
        { label: 'LOHUSA İZLEMİ', count: '' },
        { label: 'YENİDOĞAN İZLEMİ', count: '' }
      ]
    },
    committee: {
      type: Array,
      default: () => [
        { role: 'Komisyon Başkanı', name: '', date: '' },
        { role: 'Komisyon Üyesi', name: '', date: '' },
        { role: 'Komisyon Üyesi', name: '', date: '' }
      ]
    },
    departmentHead: {
      type: Object,
      default: () => ({
        role: 'Bölüm Başkanı',
        name: '',
        date: ''
      })
    }
  },
  methods: {
    generatePDF() {
      const element = this.$refs.pdfArea;

      const options = {
        margin: 2, // A4 kenar boşluğu sıfırlandı (padding CSS içinden yönetiliyor)
        filename: `mezuniyet_kriter_formu_${this.studentInfo.number || 'ogrenci'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().set(options).from(element).save();
    },
    bicimliKopyala() {
      const alan = document.getElementById("yazdirilacak-alan");
      const range = document.createRange();
      range.selectNodeContents(alan);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand("copy");
        alert("Biçimlendirilmiş metin kopyalandı! Word'e yapıştırabilirsiniz.");
      } catch (err) {
        alert("Kopyalama başarısız oldu.");
      }

      selection.removeAllRanges();
    }
  }
}
</script>

<style scoped>
/* Ekran Buton Alanı */
.no-pdf-actions {
  max-width: 210mm;
  margin: 10px auto;
  display: flex;
  justify-content: flex-end;
}

/* A4 Kapsayıcı Konfigürasyonu */
.form-container {
  width: 210mm;
  height: 297mm;
  max-height: 297mm;
  margin: 0 auto;
  background: #ffffff;
  padding: 12mm 15mm; /* İç boşluklar dikeyde sığması için optimize edildi */
  box-sizing: border-box;
  font-family: 'Times New Roman', Times, serif;
  color: #000;
  line-height: 1.3;
  overflow: hidden; /* Sayfa dışı taşmaları engeller */
}

/* Genel Tablo Yapısı */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
}

th, td {
  border: 1px solid #000;
  padding: 5px 8px;
  font-size: 10.5pt;
}

/* Başlık ve Logo Tablosu */
.header-table {
  border: none;
  margin-bottom: 15px;
}

.header-table td {
  border: none;
  padding: 0;
}

.logo-cell {
  width: 70px;
  text-align: center;
  vertical-align: middle;
}

.title-cell {
  text-align: center;
  font-size: 12pt;
  font-weight: bold;
  vertical-align: middle;
}

/* Bilgi Tablosu */
.bilgi-tablosu th {
  background-color: #f2f2f2;
  text-align: left;
  font-weight: bold;
  width: 38%;
}

/* Kriter Tablosu */
.kriter-tablosu th {
  text-align: center;
  background-color: #f2f2f2;
  font-weight: bold;
}

.kriter-tablosu th:first-child {
  width: 70%;
}

.center-text {
  text-align: center;
}

/* Metinler */
.onay-metni {
  text-align: justify;
  margin: 12px 0;
  font-size: 10.5pt;
  text-indent: 20px;
}

/* İmza Alanı Tablosu */
.imza-tablosu {
  margin-top: 15px;
  text-align: center;
}

.imza-tablosu td {
  width: 33.33%;
  font-size: 10pt;
}

.imza-satiri td {
  height: 40px;
  vertical-align: top;
  text-align: left;
}

/* Bölüm Başkanı Alanı */
.bolum-baskani {
  text-align: center;
  margin-top: 12px;
}

.bold-text {
  font-weight: bold;
  font-size: 11pt;
  margin: 0;
}

.imza-alani {
  margin-top: 5px;
  font-size: 10pt;
}

/* Sistem Notu */
.sistem-notu {
  text-align: center;
  font-size: 8.5pt;
  margin-top: 15px;
  color: #444;
}

/* Baskı Kuralı */
@media print {
  .no-pdf-actions {
    display: none !important;
  }
  .form-container {
    box-shadow: none;
    padding: 10mm;
  }
}
</style>